export default "__VITE_ASSET__Cf9Xzl5G__"